declare let THREE: any;
import {Injectable} from '@angular/core';
import {DragHandlerBase} from './drag-handler-base';
import {CollisionService} from '../../../../services/collision/collision.service';
import {RotationByYCalculator} from '../Class/RotationByYCalculator';

const direction = {
  HORIZONTAL: 0,
  VERCTICAL: 1
};

class FloorObjectSmartDragHandler extends DragHandlerBase {

  private up: any;
  private directions: any;
  private moveDirection: any;
  private colliderCache: any;
  private yRotationCalculator = new RotationByYCalculator();

  constructor(
    nextHandler,
    private collisionSrvc: CollisionService
  ) {
    super(nextHandler);

    this.up = new THREE.Vector3(0, 1, 0);

    this.directions = [direction.HORIZONTAL, direction.VERCTICAL];

    this.moveDirection = new THREE.Vector3();

    this.colliderCache = {};
  }

  private getMoveDirection(object, moveDirection, dragDirection) {

    if (moveDirection === direction.HORIZONTAL) {
      this.moveDirection.set(Math.sign(dragDirection.x), 0, 0);
    } else {
      this.moveDirection.set(0, 0, Math.sign(dragDirection.z));
    }

    const angle = this.yRotationCalculator.calculate(object);

    return this.moveDirection.applyAxisAngle(this.up, angle);
  }

  move(e, transformation) {

    if (e.draggedObjects.length === 1) {

      let collidedObject = this.collisionSrvc.isCollide(e.draggedObject, e.staticObjects, {
        newPosition: transformation.position,
        newRotation: transformation.rotation,
        staticColliderCache: this.colliderCache
      });

      if (collidedObject) {
        const {draggedObject, draggedObjectWorldTransform} = e;
        const diff = transformation.position.clone().sub(draggedObjectWorldTransform.position);
        const dragDirection = diff.clone().normalize();

        let i = 0,
          currentMoveDirection,
          moveDirection,
          projection,
          newPosition;

        for (; i < this.directions.length; i++) {

          currentMoveDirection = this.directions[i];
          moveDirection = this.getMoveDirection(collidedObject, currentMoveDirection, dragDirection);
          projection = diff.clone().projectOnVector(moveDirection);
          newPosition = draggedObjectWorldTransform.position.clone().add(projection);

          collidedObject = this.collisionSrvc.isCollide(draggedObject, e.staticObjects, {
            newPosition: newPosition,
            newRotation: transformation.rotation,
            staticColliderCache: this.colliderCache
          });

          if (!collidedObject) {
            transformation.position = newPosition;
            break;
          }
        }
      }
    }

    super.move(e, transformation);
  }

  release(e) {
    this.colliderCache = {};
    super.release(e);
  }

}

@Injectable()
export class FloorObjectSmartDragHandlerFactory {

  constructor(
    private collisionSrvc: CollisionService
  ) {
  }

  create(nextHandler?): DragHandlerBase {
    return new FloorObjectSmartDragHandler(
      nextHandler,
      this.collisionSrvc
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/Drag/Handler/floor-object-smart-drag.ts